<div class="dialoghead chartimage-modal">
  <mat-dialog-content>
    <div class="chart-image-wrap">
      <img
        [src]="safeSrc"
        [alt]="data?.alt || 'Chart image'"
        style="width: 70%; height: 100%; display: block"
      />
    </div>
  </mat-dialog-content>
</div>
<span mat-button mat-dialog-close class="close-btn-modal material-icons"
    >close</span
  >